var app = require('../index');

app.fn('songSearchForm.toggleSongDetails', function(e, el) {
	var $songDetails = jQuery('#song-search-form .song-details .panel-body');

	//remember the collapsed/expanded state of song details for the next time the user returns to this form
	this.model.set('_session.songSearch._showSongDetailsOnPageLoad', $songDetails.css('display') != 'block'); //!= instead of == because we're about to change it
	$songDetails.slideToggle(300);
});

//Voice range selector

app.fn('songSearchForm.toggleVoiceRangeSearch', function(e, el) {
	if (el.checked) showVoiceRangeSelector();
	/*
	//if no voice range selected yet, show the selector
	if (model.get('_page.limitVoiceRange') && !model.get('_session.songSearch.voiceRange')) {
		showVoiceRangeSelector();
	}
	*/
});

app.fn('songSearchForm.showVoiceRangeSelector', showVoiceRangeSelector);
function showVoiceRangeSelector() {
	var model = app.model;
	model.set('_page.limitVoiceRange', true);
	
	var $modal = jQuery('#range-selector-modal');

	var rangeSelector = model.get('_page.rangeSelector');
	if (!rangeSelector) {
		//render the piano
        var rangeSelector = new RangeSelectorView($('#range-selector-conatiner'));
        rangeSelector.draw();

		$modal.on('hide.bs.modal', doneSelectingVoiceRange);

		$modal.find('.btn-cancel').click(function() {
			$('#range-selector-confirm-cancel-modal').modal('show');
        });
        //we decided to remove the cancel button (due to possible confusion between discarding *changes* and discarding the voice range limit entirely)
//		$('#range-selector-confirm-cancel-modal .btn-yes').click(function() {
//			model.set('_page.rangeSelectorCanceled', true);
//		});
		$('#range-selector-confirm-cancel-modal').on('hide.bs.modal', function() {
			if (model.get('_page.rangeSelectorCanceled'))
				$modal.modal('hide'); //close the voice selector modal
		});

        model.set('_page.rangeSelector', rangeSelector);
	}

	//if a range has not yet been selected, default to the standard range for the voice type
	var currentVoiceRange = model.get('_session.songSearch.voiceRange');
	if (!currentVoiceRange) {
		//Commenting for now; need to make this clearer to the user
		//
        //if a single voice type is selected, initialize with that voice type
        //(we could do multiple voice types too but that would be a bit more complicated)
		/*
        var voiceType = model.get('_session.songSearch.voiceType');
        if (voiceType && voiceType != 'multiple') {
            var voiceTypeMap = {
                'Soprano': 'Soprano',
                'Mezzo/Belt/Alto': 'Alto',
                'Tenor': 'Tenor',
                'Baritone/Bass': 'Bass'
            };
            rangeSelector.setVoiceType(voiceTypeMap[voiceType]);
        }
		*/
    }
    else {
		rangeSelector.setRange(currentVoiceRange.lowestNote, currentVoiceRange.highestNote);
    }

	$modal.modal({
		keyboard: false //don't allow to close window by using escape key (to avoid OK/cancel ambiguity)
		//also don't allow clicking outside to close the window (since dragging past the end of the window
		//could accidentally happen while dragging the slider)
	  , backdrop:'static'
	})
	.modal('show');
}

function doneSelectingVoiceRange() {
	var model = app.model;
	var rangeSelector = model.get('_page.rangeSelector');
	var minMidiNum = rangeSelector.getMinMidiNum(),
	    maxMidiNum = rangeSelector.getMaxMidiNum();

	var range = rangeSelector.getRange();

	//Cancel button was removed; see note above
	//
	//check to see if the cancel button was pressed
	/*
	if (model.get('_page.rangeSelectorCanceled')) {
		//If no voice range was selected yet, set back to no voice range.
		//If a voice range WAS previously selected, we don't need to do anything, because the voice range selector
		//will be updated with those values the next time it's opened
		if (!model.get('_session.songSearch.voiceRange')) {
			rangeSelector.clearRange();
			//if the voice range selector was opened for the first time but no changes were made and the user clicked Cancel,
			//go back to "Don't limit voice range"
			model.set('_page.limitVoiceRange', false);
		}

		model.set('_page.rangeSelectorCanceled', false);
		return;
	}
	*/

	//update the model with the new voice range
	//
	//if neither note is being limited, check the "Don't limit voice range" box
	if (!range.lowestNote && !range.highestNote) {
		model.set('_page.limitVoiceRange', false);
		model.del('_session.songSearch.voiceRange');
	}
	else {
		model.set('_session.songSearch.voiceRange', range);
		model.set('_page.voiceRangeDisplayString', rangeSelector.getRangeDisplayString());
	}
}